document.addEventListener('DOMContentLoaded', function() {
  var forms = document.querySelectorAll('.footer-newsletter__form');

  forms.forEach(function(form) {
    var listId = form.getAttribute('data-klaviyo-list-id');
    var publicKey = form.getAttribute('data-klaviyo-public-key');
    if (!listId || !publicKey) return;

    var emailInput = form.querySelector('input[type="email"]');
    var successMessage = form.querySelector('.footer-newsletter__message--success');
    var errorMessage = form.querySelector('.footer-newsletter__message--error');
    var submitButton = form.querySelector('button[type="submit"]');
    var originalButtonText = submitButton ? submitButton.textContent : '';
    var messageTimer;

    function showMessage(target, text) {
      if (!target) return;
      target.textContent = text;
      target.hidden = false;
      target.style.display = 'block';
    }

    function hideMessage(target) {
      if (!target) return;
      target.hidden = true;
      target.style.display = 'none';
    }

    function clearMessageTimer() {
      if (messageTimer) {
        window.clearTimeout(messageTimer);
        messageTimer = null;
      }
    }

    function showTimedMessage(target, text) {
      clearMessageTimer();
      showMessage(target, text);
      messageTimer = window.setTimeout(function() {
        hideMessage(target);
        messageTimer = null;
      }, 2000);
    }

    hideMessage(successMessage);
    hideMessage(errorMessage);

    form.addEventListener('input', function() {
      clearMessageTimer();
      hideMessage(successMessage);
      hideMessage(errorMessage);
    });

    form.addEventListener('submit', function(event) {
      event.preventDefault();

      clearMessageTimer();
      hideMessage(successMessage);
      hideMessage(errorMessage);

      if (!emailInput || !emailInput.value.trim()) {
        showTimedMessage(errorMessage, 'Please enter a valid email address.');
        return;
      }

      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(emailInput.value.trim())) {
        showTimedMessage(errorMessage, 'Please enter a valid email address.');
        return;
      }

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = '...';
      }

      var data = new URLSearchParams();
      data.append('g', listId);
      data.append('email', emailInput.value.trim());

      fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe?company_id=' + encodeURIComponent(publicKey), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: data.toString()
      })
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Klaviyo subscription failed');
          }
          form.reset();
          showTimedMessage(successMessage, 'Thanks for subscribing.');
        })
        .catch(function() {
          showTimedMessage(errorMessage, 'Something went wrong. Please try again.');
        })
        .finally(function() {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = originalButtonText;
          }
        });
    });
  });
});
